
























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { Filter } from '../../../types/ProcessTypes';

@Component
export default class ProcessListFilter extends Vue {
  @Getter('processModule/categories') categories!: string[];

  filter: Filter = {
    search: '',
    category: 'All',
  };

  @Watch('filter', { deep: true })
  onFilterChanged() {
    const filterObject: Filter = {
      search: this.filter.search,
      category: this.filter.category,
      requiredWords: this.filter.search.toLowerCase().split(' '),
    };
    this.setNewFilter(filterObject);
  }

  @Action('processModule/setNewFilter') setNewFilter: any;
}
